export const BASE_URL = process.env.REACT_APP_BACKND_URL ?? "http://localhost:8080";